/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Accordion, AccordionHeader, AccordionPanel, Tag, Typography2 } from '@coursera/cds-core';

import type { CourseUpdateInfo } from 'bundles/s12n-common/components/s12n-versioning-v2/useFetchS12nVersioningInfo';

import _t from 'i18n!nls/program-home';

const styles = {
  itemHeader: css`
    margin: var(--cds-spacing-200) 0 var(--cds-spacing-100);
  `,
  tag: css`
    margin-right: var(--cds-spacing-100);
  `,
};

type Props = {
  course: CourseUpdateInfo;
};

const CourseInfo = ({ course }: Props) => {
  return (
    <Accordion>
      <AccordionHeader label={course.name} />

      <AccordionPanel>
        <Typography2 css={styles.itemHeader} variant="subtitleMedium" component="h4">
          {_t('What you’ll learn')}
        </Typography2>
        <Typography2 variant="bodyPrimary" component="span">
          {course.whatYouLearn}
        </Typography2>

        <Typography2 css={styles.itemHeader} variant="subtitleMedium" component="h4">
          {_t('Skills you’ll gain')}
        </Typography2>
        <div>
          {course.skills.map((skill) => (
            <Tag key={skill} css={styles.tag} variant="status" priority="primary">
              {skill}
            </Tag>
          ))}
        </div>
      </AccordionPanel>
    </Accordion>
  );
};

export default CourseInfo;
